import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { brandByExternalId_brandByExternalId, brandByExternalId_brandByExternalId_properties } from 'src/app/shared/graphql/types/brandByExternalId';
import { PropertyService } from './../../shared/services/property.service';
import { formatInTimeZone } from 'date-fns-tz'
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { propertiesFeaturedHotelByBrand_propertiesFeaturedHotelByBrand } from './types/propertiesFeaturedHotelByBrand';
import { GoogleMapStyles } from 'src/app/shared/config/googleMaps.config';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { propertySearchFn } from 'src/app/shared/functions/propertySearchFn';

import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  @ViewChild('nav') nav!: NgbNav;
  active:string = "FAIRBRIDGE INN & SUITES";
  properties: brandByExternalId_brandByExternalId_properties[] = [];
  brand: brandByExternalId_brandByExternalId;
  options: UntypedFormGroup;
  selectedDateRange: any;
  featuredProperties: brandByExternalId_brandByExternalId_properties[];
  querySubscription: Subscription;
  propertiesGroup: any = {};
  hotelCategories: string[] = ['Fairbridge Inn & Suites', 'FairBridge Inn Express', 'Loyalty Inn', 'By FairBridge'];
  mapInfoWindowProperty: brandByExternalId_brandByExternalId_properties;
  assets_base: string = environment.assets_base;
  propertySearchFn = propertySearchFn;
  propertyLoading: boolean;
  showMore: boolean[] = [false, false, false, false];
  showMoreLimit: number = 100;
  homeSlides: any[] = [];
  currentSlide: number = 0;

  brands: {
    id: string;
    title: string;
    logo: string;
    name: string;
    hotelCategoryIndex: number;
  }[] = [
    {
      id: 'FAIRBRIDGE INN & SUITES',
      title: 'INN & SUITES',
      logo: 'assets/svg/FairBridgeInn_Suites_Logo.svg',
      name: 'FAIRBRIDGE INN & SUITES', 
      hotelCategoryIndex: 0
    },
    {
      id: 'FAIRBRIDGE INN EXPRESS',
      title: 'EXPRESS',
      logo: 'assets/svg/FairBridgeInn_Express_Logo.svg',
      name: 'FAIRBRIDGE INN EXPRESS',
      hotelCategoryIndex: 1
    },
    {
      id: 'FAIRBRIDGE LOYALTY INN', 
      title: 'LOYALTY INN',
      logo: 'assets/images/brand/LoyaltyInn_logo.webp',
      name: 'FAIRBRIDGE LOYALTY INN',
      hotelCategoryIndex: 2
    },
    {
      id: 'BY FAIRCLOUD',
      title: 'BY FAIRCLOUD',
      logo: 'assets/images/brand/by-faircloud_logo.webp',
      name: 'BY FAIRCLOUD',
      hotelCategoryIndex: 3
    },
  ];

  googleMapOptions: google.maps.MapOptions = {
    styles: GoogleMapStyles,
    disableDefaultUI: true,
    backgroundColor: '#000000'
  }

  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: 'assets/images/map-marker-blue-home.png'
  }

  constructor(
    fb: UntypedFormBuilder,
    private propertyService: PropertyService,
    private titleService: Title,
    private meta: Meta
  ) {
    this.options = fb.group({
      checkin: new UntypedFormControl(null),
      checkout: new UntypedFormControl(null),
      rooms: new UntypedFormControl(1),
      adults: new UntypedFormControl(1),
      children: new UntypedFormControl(0),
      promo: new UntypedFormControl(null),
      webUrl: new UntypedFormControl(null),
    });
  }

  ngOnInit(): void {
    this.getBrandDetails();

    this.titleService.setTitle("FairBridge Hotels");
    this.meta.addTags([
      { name: 'title', content: "FairBridge Hotels" },
      { name: 'description', content: "Whether it's the east coast, west coast or anywhere in-between, you can rely on Fairbridge Hotels to help you find the place that suits your wants, needs and most importantly your style." },
      { name: 'robots', content: 'index, follow' }
    ]);
  }

  showMoreBrandChilds(index: number) {
    this.showMore[index] = !this.showMore[index];
  }

  getBrandDetails() {
    this.propertyLoading = true;
    this.propertyService.brand$.subscribe(res => {
      this.brand = res;
      this.properties = [...this.brand.properties];
      this.properties = this.properties.sort((a, b) => 
        (a?.state ?? '').toUpperCase().localeCompare((b?.state ?? '').toUpperCase())
      );
      // this.featuredProperties = this.brand.properties.filter(entry => (entry.featuredHotel === true));
      this.includesHotelCategory();
      this.propertyLoading = false;
      this.getTopSlides();
    });
  }

  getTopSlides(accessCode: string = 'SLIDE') {
    this.homeSlides = this.brand.images.filter(entry => (entry.accessCode === accessCode && entry.status === 'ACTIVE'));
    // afterNextRender(() => {
    //   if (this.homeSlides.length) {
    //     const source = interval(7500);
    //     source.subscribe(_ => this.onNextClick());
    //   }
    // });
  }

  onNextClick() {
    const next = this.currentSlide + 1;
    this.currentSlide = next === this.homeSlides.length ? 0 : next;
  }

  setSlide(index: number) {
    this.currentSlide = index;
  }

  getFeaturedImages(entry: propertiesFeaturedHotelByBrand_propertiesFeaturedHotelByBrand, accessCode: string = '006') {
    return environment.assets_base + entry.propertyImages
      .find(entry => entry.accessCode === accessCode).imagePath;
  }

  getAdults(adults: number) {
    this.options.patchValue({
      adults: adults
    });
  }

  getChildren(children: number) {
    this.options.patchValue({
      children: children
    });
  }

  openInfoWindow(marker: MapMarker, property: brandByExternalId_brandByExternalId_properties) {
    this.infoWindow.open(marker);
    this.mapInfoWindowProperty = property;
  }

  getFeaturedImage() {
    const imageFind = this.mapInfoWindowProperty.propertyImages.find(entry => entry.accessCode === '001');
    const imagePath = imageFind ? imageFind.imagePath : null;
    return  imagePath ? this.assets_base + imagePath : null;
  }

  bookNow() {
    this.options.patchValue({
      checkin: formatInTimeZone(new Date(this.selectedDateRange.startDate.$d), 'UTC', 'yyyy-MM-dd'),
      checkout: formatInTimeZone(new Date(this.selectedDateRange.endDate.$d), 'UTC', 'yyyy-MM-dd')
    })
    const params = Object.entries({
      checkin: this.options.value.checkin && this.options.value.checkout ? this.options.value.checkin : null,
      checkout: this.options.value.checkin && this.options.value.checkout ? this.options.value.checkout : null,
      rooms: this.options.value.rooms,
      adults: this.options.value.adults,
      children: this.options.value.children,
      promo: this.options.value.promo
    })
    .filter(([_, value]) => value !== null)
    .map(([key, value]) => `${key}=${value}`);

    let bookNowURL = this.options.value.webUrl
    if (bookNowURL) {
      if (params.length) {
        bookNowURL = bookNowURL + '&' + params.join('&');
      }
      window.location.href = bookNowURL;
    }
  }

  includesHotelCategory() {
    for (let i = 0; i <= this.hotelCategories.length; i++) {
      let list = this.properties.filter(entry => {
        return entry.hotelCategory.includes(this.hotelCategories[i]);
      });
      this.propertiesGroup[this.hotelCategories[i]] = list;
    }
  }
}
